import React from 'react'
import PropTypes from 'prop-types';
import styled from 'styled-components';

const Ellipse = styled.div`
    overflow: hidden;
    position: relative;
    line-height: 20px;
    height: 80px;
    text-align: center;
    margin-right: -1em;
    padding-right: 1em;
    display: flex;
    justify-content: center;
    margin: auto;
    width: inherit;
    margin-bottom: 20px;
`;

function MultiLineEllipse({maxLine, children}) {
    return (
        <Ellipse maxLine={maxLine}>
                    {children}
        </Ellipse>
    )
}

MultiLineEllipse.propTypes = {
    children: PropTypes.node,
}

export default MultiLineEllipse

